import { NotificationsDetailTable } from 'features/notification/components/notification-list-table/notifications-detail';
import { NotificationDetailTopBarLists } from 'features/notification/components/top-bar/notifications-details-top-bar';
import { NotificationDetailsFilterFormValues, NotificationDetailsFilterFormValuesPaginated } from 'features/notification/components/type';
import { useGetNotificationDetailLists } from 'features/notification/use-cases/get-notifications-detail';
import { usePaginationParams } from 'hooks';
import { Outlet,useParams } from 'react-router-dom';

const getInitialFilterValues: NotificationDetailsFilterFormValues = {
    NotificationId: undefined,
    customerName: undefined,
    status: undefined,
    DeliveryType:undefined
};

export const NotificationsDetailView = () => {
    // const [filterValue, setFilterValue] = useState(getInitialFilterValues);
      const { id } = useParams();
      
      const initialValues: NotificationDetailsFilterFormValues = {
    ...getInitialFilterValues,
    NotificationId: id ? Number(id) : undefined,
  };

    const { params, updateParams, resetPage } =
        usePaginationParams<NotificationDetailsFilterFormValuesPaginated>({
            page: 1,
            size: 10,
            order_by: 'id',         
            ...initialValues,
        });

   
    const { data, refetch, isFetching } = useGetNotificationDetailLists(params, { retry: false });
    const handleFiltersChange = (values: NotificationDetailsFilterFormValuesPaginated) => {
        // setFilterValue(values);
        updateParams(values);
        resetPage();
        refetch();
    };

    return (
        <>
         
            <NotificationDetailTopBarLists
                handleFilter={handleFiltersChange}
                getInitialFilterValues={initialValues}
               

            />


            <NotificationsDetailTable
                isUsersListLoading={isFetching}
                typeReportList={data?.items as any}
                itemsCount={data?.total as number}
                tableParams={params}                
                updateParams={updateParams}
             refetch={refetch}

                
            />
            <Outlet />
        </>
    );
};
